<template>
  <v-select
      rounded="lg"
      variant="outlined"
      color="primary"
  >
    <template v-if="$slots.prepend" v-slot:prepend="slotProps">
      <slot name="prepend" v-bind="slotProps"></slot>
    </template>

    <template v-for="(slotContent, slotName) in $slots" :key="slotName" v-slot:[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps"></slot>
    </template>

    <template v-if="$slots.append" v-slot:append="slotProps">
      <slot name="append" v-bind="slotProps"></slot>
    </template>
  </v-select>
</template>

<script setup>
</script>

<style scoped>
</style>
